define(function() {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    urlRoot: "/delegate/civics-api/api",
    url: function() {
      var url = this.urlRoot;

      url+="/core/attachments/documenttypes/" + this.encodeComponent(this.get("name"));

      return url;
    }
  });
});
